module.exports = "<td routerLink=\"{{'../'+link}}\" attr.rowspan=\"{{rowspan}}\" class=\"center oral areas\">\n  <a>{{title}}</a>\n</td>"